<template>
  <div class="wrapper">
    <div class="wrapper-header">
      <span>
        <a-icon type="wallet" class="margin-right-small" />
        Master Credit Card
      </span>
      <a-button-group ghost>
        <!-- <a-button @click="handleReload" icon="reload">
          <span>Reload</span>
        </a-button> -->
        <a-button v-if="isKeuangan" icon="plus" type="primary" @click="handleCreate">
          <span>Create</span>
        </a-button>
      </a-button-group>
    </div>
    <div class="wrapper-body">
      <a-card>
        <a-row :gutter="16">
          <a-col :xs="{ span: 24 }" :lg="{ span: 21 }">
            <a-input-search v-model="search" :onchange="moreSearch" placeholder="Quick Search" />
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 3 }">
            <a-button :class="getScreen ? 'margin-top' : ''" block
              :icon="advancedsearch == 'display:none' ? 'down' : 'up'" @click="handleshowMore">{{
                advancedsearch == "display:none" ? "More" : "Less"
              }}</a-button>
          </a-col>
        </a-row>
        <a-row :style="advancedsearch" :gutter="16" class="margin-top">
          <a-col :xs="{ span: 24 }" :lg="{ span: 6 }">
            <div class="m-form-item-wrapper">
              <label>Report Date</label>
              <a-range-picker :placeholder="['Start Date', 'End Date']" v-model="reportDt"
                :format="getDefaultDateFormat" allowClear />
            </div>
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 6 }">
            <div class="m-form-item-wrapper">
              <label>Due Date Pay</label>
              <a-range-picker :placeholder="['Start Date', 'End Date']" v-model="dueDt"
                :format="getDefaultDateFormat" allowClear />
            </div>
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 6 }">
            <div class="m-form-item-wrapper">
              <label>Expired Date</label>
              <a-range-picker :placeholder="['Start Date', 'End Date']" v-model="exDt"
                :format="getDefaultDateFormat" allowClear />
            </div>
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 6 }">
            <div class="m-form-item-wrapper">
              <label>Status</label>
              <a-select showSearch v-model="typestatus" placeholder="All Status" class="width-full" initialValue="all"
                allowClear :filterOption="filterOption">
                <a-select-option value="1">Active</a-select-option>
                <a-select-option value="0">Non Active</a-select-option>
              </a-select>
            </div>
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
            <div class="m-form-item-wrapper">
              <label>Bank</label>
              <a-select placeholder="All Bank" v-model="typebankaccount" class="width-full" initialValue="all"
                :filterOption="filterOption" showSearch allowClear>
                <a-select-option v-for="item in getBank" :key="item.name" :value="item.name">{{ item.name
                }}</a-select-option>
              </a-select>
            </div>
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 6 }">
            <div class="m-form-item-wrapper">
              <label>Type</label>
              <a-select placeholder="All Bank" v-model="typecc" class="width-full" initialValue="all"
                :filterOption="filterOption" showSearch allowClear>
                <a-select-option v-for="item in typeList" :key="item.jenis" :value="item.jenis">{{ item.jenis
                }}</a-select-option>
              </a-select>
            </div>
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 6 }">
            <div class="m-form-item-wrapper">
              <label>Category</label>
              <a-select placeholder="All Bank" v-model="categorycc" class="width-full" initialValue="all"
                :filterOption="filterOption" showSearch allowClear>
                <a-select-option v-for="item in categoryList" :key="item.kategori" :value="item.kategori">{{ item.kategori
                }}</a-select-option>
              </a-select>
            </div>
          </a-col>
          <!-- <a-col :xs="{ span: 24 }" :lg="{ span: 4 }">
            <div
              class="m-form-item-wrapper"
            >
              <label>Type</label>
              <a-select
                showSearch
                v-model="type_debcred"
                placeholder="All Type"
                class="width-full"
                initialValue="undefined"
                allowClear
                :filterOption="filterOption"
              >
                <a-select-option value="Debit">Debit</a-select-option>
                <a-select-option value="Credit">Credit</a-select-option>
              </a-select>
            </div>
          </a-col> -->
        </a-row>
      </a-card>
      <div class="bordered">
        <a-table rowKey="id_user_cc" key="cctable" size="small" bordered :scroll="{ x: 1300 }" :columns="columns"
          :dataSource="tempdatacreditcard" :loading="loading">
          <template slot="nomor" slot-scope="text, data, index">
            <span>{{ index + 1 }}</span>
          </template>
          <template slot="limit" slot-scope="text, data">
            <!-- <span>{{ formatRupiah(data.value) }}</span> -->
            <CurrencyJustified :currencyValue="'IDR'" :valueNumber="(data.limit_kredit ? data.limit_kredit : 0)" />
          </template>
          <!-- <template slot="reqGuarantee" slot-scope="text, data">
            {{ data.bidbond_notrans }}<br />
            {{ data.bidbond_companion }}<br />
            {{ formatRupiah(data.bidbond_nominal) }}
          </template> -->
          <template slot="rd" slot-scope="item">
            {{ item.report_dt ? moment(item.report_dt).format("DD-MM-YYYY") : ''}}
          </template>
          <template slot="dd" slot-scope="item">
            {{ item.due_date_pay ? moment(item.due_date_pay).format("DD-MM-YYYY") : ''}}
          </template>
          <template slot="ed" slot-scope="item">
            {{ item.exp_dt ? moment(item.exp_dt).format("DD-MM-YYYY") : ''}}
          </template>
          <template slot="sts" slot-scope="item">
            <a-tag :color="item.aktif_sts=='1'?'green':'red'">{{item.aktif_sts=='1'?'ACTIVE':'NON ACTIVE'}}</a-tag>
          </template>
          <template slot="act" slot-scope="text, data">
            <a-button-group>
              <a-tooltip class="m-tooltip-inner" placement="bottomLeft">
                <template slot="title">
                  <span>Edit</span>
                </template>
                <a-button type="secondary" @click="handleEdit(data)" :disabled="data.aktif_sts != '1'" icon="edit">
                </a-button> 
              </a-tooltip>
              <a-tooltip class="m-tooltip-inner" placement="bottomLeft">
                <template slot="title">
                  <span>Set Non Active</span>
                </template>
                <a-button :disabled="data.aktif_sts != '1'" type="danger" icon="stop" @click="handledeaktifasi(data)">
                </a-button>
              </a-tooltip>
              <!-- <a-button size="small" :disabled="!data.file_url" type="default" @click="handleViewFile(data)" icon="eye">
              </a-button> -->
            </a-button-group>
          </template>
        </a-table>
      </div>
    </div>

    <a-modal v-if="modalCreate" v-model="modalCreate" :title="modalMode=='Create'?'Create Credit Card':'Edit Credit Card'" :width="600" centered
      :maskClosable="false" @ok="handleOk" @cancel="handleClose" okText="OK" cancelText="Cancel">
      <a-form-model ref="ccform" :model="form" :rules="rules">
        <a-row :gutter="24">
          <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
            <a-form-model-item ref="type_cc" label="Bank" prop="type_cc">
              <!-- <a-select placeholder="Select Type" v-model="form.type_cc" class="width-full" :filterOption="filterOption"
                showSearch allowClear>
                <a-select-option
                  v-for="bank in getBank"
                  :key="bank.code"
                  :value="bank.name"
                >{{bank.name}} ({{bank.code}})</a-select-option>
              </a-select> -->
              <a-auto-complete
                v-model="form.type_cc"
                placeholder="type the type of CC"
                :dropdownMatchSelectWidth="false"
                optionLabelProp="value"
                @search="handleSearchSuggest"
              >
              <template slot="dataSource">
                <a-select-option v-for="(items,index) in resultSuggestBank" :key="index" :value="items.name">
                  {{ items.name }}
                </a-select-option>
              </template>
              </a-auto-complete>
              <!-- <a-auto-complete
                class="certain-category-search"
                dropdownClassName="certain-category-search-dropdown"
                :dropdownMatchSelectWidth="false"
                optionLabelProp="value"
                v-model="form.type_cc"
              >
                <template slot="dataSource">
                  <a-select-option v-for="item in getBank" :key="item.code" :value="bank.name" >{{bank.name}}</a-select-option>
                </template>
                <a-input>
                  <a-icon slot="suffix" type="search" class="certain-category-icon" />
                </a-input>
              </a-auto-complete> -->
            </a-form-model-item>
            <a-form-model-item ref="kategori_cc" label="Category" prop="kategori_cc">
              <a-select placeholder="Select Category" v-model="form.kategori_cc" class="width-full" :filterOption="filterOption"
                showSearch allowClear>
                <a-select-option value="Direksi">{{ 'Direction' }}</a-select-option>
                <a-select-option value="Purchasing">{{ 'Purchasing' }}</a-select-option>
                <a-select-option value="Other">{{ 'Other' }}</a-select-option>
                <a-select-option value="Travel">{{ 'Travel' }}</a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item ref="jenis_cc" label="Type_cc" prop="jenis_cc">
              <a-select placeholder="Select Type" v-model="form.jenis_cc" class="width-full" :filterOption="filterOption"
                showSearch allowClear>
                <a-select-option value="Corporate">{{ 'Corporate' }}</a-select-option>
                <a-select-option value="Non Corporate">{{ 'Non Corporate' }}</a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item ref="pengguna_cc" label="User" prop="pengguna_cc">
              <a-select placeholder="Select User" v-model="form.pengguna_cc" class="width-full" :filterOption="filterOption"
                showSearch allowClear>
                <a-select-option
                  v-for="karyawan in getAllKaryawan"
                  :key="karyawan.tlc"
                >{{karyawan.tlc}} - {{karyawan.nama}}</a-select-option> 
              </a-select>
            </a-form-model-item>
            <a-form-model-item ref="no_cc" label="CC Number" prop="no_cc">
              <a-input v-model="form.no_cc"/>
            </a-form-model-item>

            <!-- <a-form-model-item ref="date" label="Date" prop="date">
              <a-date-picker v-model="form.date" format="DD-MM-YYYY" />
            </a-form-model-item>
            <a-form-model-item ref="type" label="Type" prop="type">
              <a-radio-group buttonStyle="solid" v-model="form.type_bank_guarantee">
                <a-radio-button value="1">Bloked Fund</a-radio-button>
                <a-radio-button value="2">PBG</a-radio-button>
              </a-radio-group>
            </a-form-model-item>
            <a-form-model-item ref="bank" label="Bank Account" prop="bank">
              <a-select placeholder="All Bank Account" v-model="form.bank" class="width-full" :filterOption="filterOption"
                showSearch allowClear @blur="() => {
                  $refs.bank.onFieldBlur();
                }
                  ">
                <a-select-option v-for="item in bank" :key="item.value" :value="item.value">{{ item.text
                }}</a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item ref="reqGuarantee" label="No. Request Guarantee" prop="reqGuarantee">
              <div class="m-form-item-wrapper">
                <a-select placeholder="All Request Guarantee" v-model="form.reqGuarantee" class="m-select width-full"
                  :filterOption="filterOptionNoGuarantee" showSearch allowClear @blur="() => {
                    $refs.reqGuarantee.onFieldBlur();
                  }
                    ">
                  <a-select-option v-for="item in reqGuaranteeList" :key="item.id" :value="item.id">
                    <div>
                      <b>{{ item.no_trans }}</b> | {{ item.companion_nm }} | {{ formatRupiah(item.nominal) }}
                    </div>
                  </a-select-option>
                </a-select>
              </div>
            </a-form-model-item>
            <a-form-model-item ref="description" label="Description" prop="description">
              <a-input v-model="form.description" @blur="() => {
                $refs.description.onFieldBlur();
              }
                " />
            </a-form-model-item> -->
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
            <a-form-model-item ref="limit_cc" label="Limit Value (IDR)" prop="limit_cc">
              <a-input-number :min="0" class="m-width-full m-text-align right" @keydown="onlyNumber" :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                " :parser="(value) => value.replace(/\\s?|(,*)/g, '')" v-model="form.limit_cc"></a-input-number>
            </a-form-model-item>
            <a-form-model-item ref="exp_dt" label="Expired Date" prop="exp_dt">
              <a-date-picker v-model="form.exp_dt" format="DD-MM-YYYY" />
            </a-form-model-item>
            <a-form-model-item ref="due_date_cc" label="Due Date" prop="due_date_cc">
              <a-date-picker v-model="form.due_date_cc" format="DD-MM-YYYY" />
            </a-form-model-item>
            <a-form-model-item ref="report_dt" label="Report Date" prop="report_dt">
              <a-date-picker v-model="form.report_dt" format="DD-MM-YYYY" />
            </a-form-model-item>

            <!-- <a-form-model-item ref="duedate" label="Guarantee Period Bank" prop="duedate">
              <a-range-picker :placeholder="['Start Date', 'End Date']" v-model="form.duedate"
                :format="getDefaultDateFormat" allowClear />
            </a-form-model-item>
            <a-form-model-item ref="valu" label="Value (IDR)" prop="valu">
              <a-input-number :min="0" class="m-width-full m-text-align right" @keydown="onlyNumber" :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                " :parser="(value) => value.replace(/\\s?|(,*)/g, '')" v-model="form.valu"></a-input-number>
            </a-form-model-item>
            <a-form-model-item ref="note" label="Note" prop="note">
              <a-textarea v-model="form.note" @blur="() => {
                $refs.note.onFieldBlur();
              }
                " />
            </a-form-model-item>
            <a-form-model-item ref="file" prop="file" label="File Attachment">
              <a-upload v-model="form.file" :showUploadList="true" :beforeUpload="beforeUpload"
                :remove="handleRemoveList">
                <a-button ref="btndocument" icon="upload">Select File
                </a-button>
              </a-upload>
            </a-form-model-item> -->
          </a-col>
        </a-row>
        <template slot="footer">
          <a-button key="back" @click="handleClose"> Cancel </a-button>
          <!-- <a-button @click="handleClose()">Tutup</a-button> -->

        </template>
      </a-form-model>
    </a-modal>

    <a-modal v-if="modalsetnonactive" v-model="modalsetnonactive" title="Set Non Active Form" :width="500" centered
      :maskClosable="false">
      <a-form-model ref="nonActiveform" :model="formsetnonactive" :rules="rulessetnonactive">
        <a-form-model-item ref="id" label="id" prop="id" hidden="true">
          <a-input v-model="formsetnonactive.id" @blur="() => {
            $refs.id.onFieldBlur();
          }
            " />
        </a-form-model-item>
        <a-form-model-item ref="notrans" label="No Transaction" prop="notrans">
          <a-input v-model="formsetnonactive.notrans" @blur="() => {
            $refs.notrans.onFieldBlur();
          }
            " :disabled="true" />
        </a-form-model-item>
        <a-form-model-item ref="date" label="Date" prop="date">
          <a-date-picker v-model="formsetnonactive.date" format="DD-MM-YYYY" :allowClear="false" />
        </a-form-model-item>
      </a-form-model>
      <template slot="footer">
        <a-button type="danger" key="back" @click="handleClosesetnonactive"> Cancel </a-button>
        <a-button type="primary" key="submit" :loading="loadingsetnonactive" @click="handleOksetnonactive"> OK </a-button>
        <!-- <a-button @click="handleClose()">Tutup</a-button> -->

      </template>
    </a-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import HandleRoute from "@/mixins/HandleRoute";
import shortingArray from "@/mixins/MultishortArray";
import GlobalMethod from "@/mixins/GlobalMethod.js";
import _ from "lodash";

export default {
  name: "CC-index",
  mixins: [CurrencyFormat, HandleRoute, shortingArray, GlobalMethod],
  props: {
    props_invoice_no: String
  },
  data() {
    return {
      tempdatacreditcard: [],
      datacreditcard: [],
      loading: false,
      loadingsetnonactive: false,
      search: undefined,
      typebankaccount: undefined,
      reportDt: [],
      dueDt:[],
      exDt:[],
      advancedsearch: "display:none",
      typestatus: undefined,
      supplier_nm: undefined,
      //type_debcred: undefined,
      bank: [],
      reqGuaranteeList: [],
      modalCreate: false,
      modalsetnonactive: false,
      form: {
        type_cc: null,
        kategori_cc: null,
        jenis_cc: null,
        pengguna_cc: null,
        no_cc: null,
        limit_cc: null,
        exp_dt: moment(),
        due_date_cc: moment(),
        report_dt: moment(),
      },
      formsetnonactive: {
        id: null,
        notrans: null,
        date: moment(),
      },
      rules: {
        type_cc: [
          {
            required: true,
            message: "Type CC is required!",
            trigger: "change",
          },
        ],
        kategori_cc: [
          {
            required: true,
            message: "Category is required!",
            trigger: "change",
          },
        ],
        jenis_cc: [
          {
            required: true,
            message: "Type CC is required!",
            trigger: "change",
          },
        ],
        pengguna_cc: [
          {
            required: true,
            message: "User is required!",
            trigger: "change",
          },
        ],
        no_cc: [
          {
            required: true,
            message: "CC Number is required!",
            trigger: "change",
          },
        ],
        limit_cc: [
          {
            required: true,
            message: "Limit Value CC is required!",
            trigger: "change",
          },
        ],
        exp_dt: [
          {
            required: true,
            message: "Expired Date is required!",
            trigger: "change",
          },
        ],
        due_date_cc: [
          {
            required: true,
            message: "Due Date is required!",
            trigger: "change",
          },
        ],
        report_dt: [
          {
            required: true,
            message: "Report Date is required!",
            trigger: "change",
          },
        ],
      },
      rulessetnonactive: {
        id: [
          {
            required: true,
            message: "Please input Id",
            trigger: "change",
          },
        ],
        notrans: [
          {
            required: true,
            message: "Please input No transaction",
            trigger: "change",
          },
        ],
        date: [
          {
            required: true,
            message: "Please input Date",
            trigger: "change",
          },
        ],
      },
      typeList:[],
      categoryList:[],
      typecc: undefined,
      categorycc: undefined,
      modalMode: 'Create',
      resultSuggestBank: []
    };
  },
  mounted() {
    this.handleReload().then(() => {
      if (this.props_invoice_no) {
        let isExistInvoice = _.filter(this.reqGuaranteeList, e => e.no_trans == this.props_invoice_no)
        if (isExistInvoice.length == 0) {
          this.displayMessageValue("error-other", "No. Request Guarantee Not Found!");
        } else {
          this.form.reqGuarantee = isExistInvoice[0].id
          this.modalCreate = true;
        }
      }
    });
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getBank",
      "getDefaultDateFormat",
      "getStandartFormatDate",
      "getAllKaryawan",
    ]),
    moreSearch: function () {
      let tempfilter = this.datacreditcard;
      if (this.datacreditcard.length > 0) {
        if (this.search) {
          tempfilter = tempfilter.filter(
            (obj) =>
            (obj.allstring &&
              obj.allstring
                .toLowerCase()
                .indexOf(this.search.toLowerCase()) >= 0)
          );
        }

        if (this.typebankaccount) {
          tempfilter = tempfilter.filter(
            (obj) =>
              obj.type_cc && obj.type_cc.toLowerCase() == this.typebankaccount.toLowerCase()
          );
        }
        
        if (this.typecc) {
          tempfilter = tempfilter.filter(
            (obj) =>
              obj.jenis && obj.jenis.toLowerCase() == this.typecc.toLowerCase()
          );
        }

        if (this.categorycc) {
          tempfilter = tempfilter.filter(
            (obj) =>
              obj.kategori && obj.kategori.toLowerCase() == this.categorycc.toLowerCase()
          );
        }

        if (this.reportDt && this.reportDt.length > 0) {
          let startDt = moment(this.reportDt[0]).format("DD-MM-YYYY");
          let endDt = moment(this.reportDt[1]).format("DD-MM-YYYY");
          tempfilter = tempfilter.filter(
            (obj) =>
              obj.report_dt &&
              moment(moment(obj.report_dt, "YYYY-MM-DD").toDate()).format("DD-MM-YYYY") >= startDt &&
              moment(moment(obj.report_dt, "YYYY-MM-DD").toDate()).format("DD-MM-YYYY") <= endDt
          );

        }

        if (this.exDt && this.exDt.length > 0) {
          let startDt = moment(this.exDt[0]).format("DD-MM-YYYY");
          let endDt = moment(this.exDt[1]).format("DD-MM-YYYY");
          tempfilter = tempfilter.filter(
            (obj) =>
              obj.exp_dt &&
              moment(moment(obj.exp_dt, "YYYY-MM-DD").toDate()).format("DD-MM-YYYY") >= startDt &&
              moment(moment(obj.exp_dt, "YYYY-MM-DD").toDate()).format("DD-MM-YYYY") <= endDt
          );

        }

        if (this.dueDt && this.dueDt.length > 0) {
          let startDt = moment(this.dueDt[0]).format("DD-MM-YYYY");
          let endDt = moment(this.dueDt[1]).format("DD-MM-YYYY");
          tempfilter = tempfilter.filter(
            (obj) =>
              obj.due_date_pay &&
              moment(moment(obj.due_date_pay, "YYYY-MM-DD").toDate()).format("DD-MM-YYYY") >= startDt &&
              moment(moment(obj.due_date_pay, "YYYY-MM-DD").toDate()).format("DD-MM-YYYY") <= endDt
          );

        }

        if (this.typestatus) {

          tempfilter = tempfilter.filter(
            (obj) =>
            (obj.aktif_sts &&
              Number(obj.aktif_sts)==Number(this.typestatus))
          );
        }
      }

      if (
        (!this.search || this.search == "") &&
        (!this.reportDt || this.reportDt.length == 0) &&
        (!this.dueDt || this.dueDt.length == 0) &&
        (!this.exDt || this.exDt.length == 0) &&
        !this.typebankaccount &&
        !this.typestatus &&
        !this.typecc &&
        !this.categorycc
      ) {
        tempfilter = this.datacreditcard;
      }

      this.tempdatacreditcard = tempfilter;
      return true;
    },
    isKeuangan(){
      let data = _.filter(this.getAuth.nama_bidang,(obj) => obj=="Keuangan");
      return data.length>0 ? true : false;
    },
    columns(){
      let columns = [
        {
          title: "#",
          key: "nomor",
          scopedSlots: { customRender: "nomor" },
          align: "right",
          width: 50,
        },
        {
          title: "Type",
          key: "date",
          dataIndex: "jenis",
          width: 200,
        },
        {
          title: "Category",
          key: "kategori",
          dataIndex: "kategori",
          width: 300,
        },
        {
          title: "TLC",
          key: "tlc_user",
          dataIndex: "tlc_user",
          align: "center",
          width: 75,
        },
        {
          title: "No. Credit Card",
          key: "ncc",
          dataIndex: "no_cc",
          width: 250,
        },
        {
          title: "Bank",
          key: "bank",
          width: 200,
          dataIndex: "type_cc",
        },
        {
          title: "Limit",
          key: "limit",
          scopedSlots: { customRender: "limit" },
          width: 200,
        },
        {
          title: "Report Date",
          key: "rd",
          scopedSlots: { customRender: "rd" },
          align: "center",
          width: 150,
        },
        {
          title: "Due Date Pay",
          key: "dd",
          width: 150,
          scopedSlots: { customRender: "dd" },
          align: "center",
        },
        {
          title: "Expired Date",
          key: "ed",
          width: 150,
          scopedSlots: { customRender: "ed" },
          align: "center",
        },
        {
          title: "Status",
          key: "sts",
          width: 150,
          scopedSlots: { customRender: "sts" },
          align: "center",
        },
      ];

      if(this.isKeuangan){
        columns.push({
          title: "Action",
          fixed: "right",
          key: "act",
          scopedSlots: { customRender: "act" },
          width: 100,
          align: "center",
          },
        )
      }
      return columns
    }
  },
  created() {
    this.$store.dispatch("FETCH_ALL_KARYAWAN");
  },
  methods: {
    moment,
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    filterOptionNoGuarantee(input, option) {
      return (
        option.componentOptions.children[0].elm.innerText
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    resetSearch() {
      this.search = undefined;
      this.reportDt = undefined;
      this.dueDt = undefined;
      this.exDt = undefined;
      this.typebankaccount = undefined;
      this.typestatus = undefined;
      //this.type_debcred = undefined;
    },
    intoList(type, value) {
      if (type == "release") {
        this.release = value;
      } else if (type == "queue") {
        this.queue = value;
      } else {
        this.needProcess = value;
      }
    },
    async handleReload() {
      this.loading = true;
      await this.$store.dispatch("getcreditcardlist", { auth: this.getAuth }).then((res) => {
        this.datacreditcard = res.data.data;
        this.datacreditcard.forEach((element, index) => {
          this.datacreditcard[index].allstring = (element.jenis ? element.jenis : "")
            + (element.kategori ? element.kategori : "")
            + (element.tlc_user ? element.tlc_user : "")
            + (element.no_cc ? element.no_cc : "")
            + (element.limit_kredit ? this.formatRupiah(element.limit_kredit) : "")
            + (element.report_dt ? moment(element.report_dt).format('DD-MM-YYYY') : "")
            + (element.due_date_pay ? moment(element.due_date_pay).format('DD-MM-YYYY') : "")
            + (element.exp_dt ? moment(element.exp_dt).format('DD-MM-YYYY') : "")
            + (element.active ? (element.active=="1"?'ACTIVE':'NON ACTIVE') : "")
        });

        this.typeList = [...new Map(this.datacreditcard.map(item =>
        [item['jenis'], item])).values()];

        this.categoryList = [...new Map(this.datacreditcard.map(item =>
        [item['kategori'], item])).values()];

        this.tempdatacreditcard = this.datacreditcard;
        this.loading = false;
      });
      this.resetSearch();
    },
    resetform() {
      this.form = {
        type_cc: null,
        kategori_cc: null,
        jenis_cc: null,
        pengguna_cc: null,
        no_cc: null,
        limit_cc: null,
        exp_dt: moment(),
        due_date_cc: moment(),
        report_dt: moment(),
      };
      this.modalMode=="Create"
      this.modalIdValue = ""
    },
    handleCreate() {
      // this.$router.push({
      //   name: "account-pay-create",
      //   params: { id: item.id, type: item.jenis_id },
      // });
      this.resetform();
      this.modalCreate = true;
    },
    handleEdit(item) {
      this.modalIdValue = item.id_user_cc
      this.form.type_cc= item.jenis,
      this.form.kategori_cc= item.kategori,
      this.form.jenis_cc= item.type_cc,
      this.form.pengguna_cc= item.tlc_user,
      this.form.no_cc= item.no_cc,
      this.form.limit_cc= item.limit_kredit,
      this.form.exp_dt= item.exp_dt?moment(item.exp_dt):null,
      this.form.due_date_cc= item.due_date_pay?moment(item.due_date_pay):null,
      this.form.report_dt= item.report_dt?moment(item.report_dt):null,

      this.modalMode= 'Edit';
      this.modalCreate = true;
    },
    handleshowMore() {
      if (this.advancedsearch == "display:none") {
        this.advancedsearch = "display:block";
      } else {
        this.advancedsearch = "display:none";
      }
    },
    handleViewFile(item) {
      window.open(this.$serviceUrl + item.file_url);
    },
    handleRemoveList() {
      this.form.file = undefined;
    },
    beforeUpload(file) {
      this.form.file = [file];
      return false;
    },
    handleClose() {
      //this.$refs.ccform.resetFields();
      this.$refs.file = null;
      this.modalCreate = false;
    },
    handleClosesetnonactive() {
      this.modalsetnonactive = false;
    },
    handleOk() {
      this.$refs.ccform.validate((valid) => {
        if (!valid) {
          this.displayMessage("form-warning");
          return;
        }

        let formData = null

        if(this.modalMode=='Create'){
          formData = new FormData();
          formData.append("pengguna_cc", this.form.pengguna_cc);
          formData.append("no_cc", this.form.no_cc);
          formData.append("type_cc", this.form.type_cc);
          formData.append("kategori_cc", this.form.kategori_cc);
          formData.append("jenis_cc", this.form.jenis_cc);
          formData.append("limit_cc", this.form.limit_cc);
          formData.append("exp_dt", moment(this.form.exp_dt).format('YYYY-MM-DD'));
          formData.append("due_date_cc", moment(this.form.due_date_cc).format('YYYY-MM-DD'));
          formData.append("report_dt", moment(this.form.report_dt).format('YYYY-MM-DD'));
        }else{
          formData = {
            pengguna_cc: this.form.pengguna_cc,
            no_cc: this.form.no_cc,
            type_cc: this.form.type_cc,
            kategori_cc: this.form.kategori_cc,
            jenis_cc: this.form.jenis_cc,
            limit_cc: this.form.limit_cc,
            exp_dt: moment(this.form.exp_dt).format('YYYY-MM-DD'),
            due_date_cc: moment(this.form.due_date_cc).format('YYYY-MM-DD'),
            report_dt: moment(this.form.report_dt).format('YYYY-MM-DD'),
            id_user_cc: this.modalIdValue
          }
        }

        this.loading = true;
        this.$store.dispatch(this.modalMode=="Create" ? "createBankCC" : "editBankCC", {
          auth: this.getAuth,
          params: formData
        })
          .then((res) => {
            if (res.data.status == true) {
              this.displayMessageValue("success-other", res.data.message);
              //this.$refs.ccform.resetFields();
              this.$nextTick(() => {
                this.form.file = undefined;
              });
              this.handleReload();
            } else {
              this.displayMessageValue(
                "error-other",
                res.data.message
              );
            }
            this.loading = false;

          })
          .catch(err => {
            console.log("err", err);
            this.loading = false;
          });
        this.modalCreate = false;
      });
    },
    handledeaktifasi(item) {
      const that = this;
      this.$confirm({
        title: "Are you sure to set non active this data?",
        content: "",
        okText:"Yes",
        cancelText:"No",
        onOk() {
          let params = item.id_user_cc
          that.$store.dispatch("nonActiveCC", { auth: that.getAuth, params })
          .then((res) => {
            if(res.data.status==true){
              that.displayMessageValue("success-other", res.data.message);
              that.handleReload();
            }else{
              that.displayMessageValue(
                "error-other",
                res.data.message
              );
            }
            that.loading = false;
          })
          .catch(err => {
            console.log(err);
              that.loading = false;
          });
        },
          onCancel() {},
        });
    },
    handleOksetnonactive() {
      this.$refs.nonActiveform.validate((valid) => {
        if (!valid) {
          this.displayMessage("form-warning");
          return;
        }

        let params = new FormData();
        params.append("tlc", this.getAuth.username);
        params.append("bank_garansi_id", this.formsetnonactive.id);
        params.append("date", moment(this.formsetnonactive.date).format("YYYY-MM-DD"));
        this.loadingsetnonactive = true;
        this.$store.dispatch("nonActiveBankGuarantee", { auth: this.getAuth, params })
          .then((res) => {
            if (res.data.status == true) {
              this.displayMessageValue("success-other", res.data.message);
              this.handleReload();
            } else {
              if (res.data.message) {
                this.displayMessageValue(
                  "error-other",
                  res.data.message
                );
              } else {
                let responses = Object.assign({}, res);
                this.displayMessageValue("error", responses);
              }
            }
            this.modalsetnonactive = false;
            this.loadingsetnonactive = false;
          })
          .catch(err => {
            let response = Object.assign({}, err.response);
            if (response.data.status == false && response.data.message) {
              this.displayMessageValue("error-other", response.data.message);
            } else {
              let responses = Object.assign({}, err);
              this.displayMessageValue("error", responses);
            }
            this.modalsetnonactive = false;
            this.loadingsetnonactive = false;
          });
      });
    },
    handleSearchSuggest(value){
      let result;
      if (!value) {
        result = [];
      } else if(value.length>=2){
        result = this.getBank.filter((item)=>{return item.name.toLowerCase().indexOf(value.toLowerCase())>=0})
      }
      this.resultSuggestBank = result;
    },
  },
};
</script>

<style lang="less" scoped>
.wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  border: 1px solid darken(white, 10);

  &-header {
    height: 50px;
    background: darken(white, 2);
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-transform: capitalize;
    font-size: 1rem;
    font-weight: 500;
    color: @color-secondary;
    border-bottom: 1px dashed darken(white, 10);
    padding: @padding;
  }

  &-body {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
}

.bordered {
  border: 1px solid darken(white, 10);
}

.custom-tabs {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.list-item {
  display: flex;
  align-items: flex-start;
}
</style>

<style lang="less">
.custom-tabs {
  .ant {
    &-tabs-bar {
      margin-bottom: 0;
    }

    &-tabs-content {
      flex: 1;
    }
  }
}

.ant-table-thead>tr>th {
  text-align: center;
}
</style>
